(function($) {
    var addressSearchFlag = false;

    // 郵便番号変更
    $(document).on('input keyup blur', '#zip', function() {
        var postcode = $('#zip').val();
        if( postcode.match( /^[0-9]{7}$/ ) ){
            addressSearch( postcode );
        }
    });

    // 住所検索ボタン
    $(".get_addr_trigger_sc").on('click', function(e) {
        var postcode = $('#zip').val();
        if( postcode.match( /^[0-9]{7}$/ ) ){
            addressSearch( postcode );
        }
    });

    // 住所検索
    function addressSearch( postcode ) {

        // 海外対応
        if( postcode == "0000000" ){
            $("#prefectures").val( "海外" );
            return true;
        }

        // 2重起動制御
        if( addressSearchFlag ) return false;
        addressSearchFlag = true;

        // 住所取得
        jQuery.support.cors = true;
        $.ajax({
            url: '/api/search_address',
            type: "GET",
            async:false,
            data: { postal_code: postcode },
            cache: false,
            dataType: 'json',
            success: function(data) {
                flag = data.result;
                // 成功時
                if( flag && data.addr){
                    $("#prefectures").val( data.addr.prefectures );
                    $("#city_area").val( data.addr.cityarea );
                    $("#city").val( data.addr.cityarea );
                    $("#street_address").val( data.addr.address );
                    $("#contact_city_area").val( data.addr.cityarea );
                    $("#seminar_city_area").val( data.addr.cityarea );
                }
            },
            complete: function(xhr, status) {
                setTimeout(function(){addressSearchFlag = false;},200);
            }
        });

    }

})(jQuery);
